import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import MediaLibrary from 'src/containers/MediaLibrary';
import RundownFormWithParams from 'src/containers/Rundowns/Form/WithParams';
import CanvasForm from 'src/containers/Settings/Canvas/Form';
import CanvasOverview from 'src/containers/Settings/Canvas/Overview';
import OutputForm from 'src/containers/Settings/Output/Form';
import OutputOverview from 'src/containers/Settings/Output/Overview';
import RundownTemplateFormWithParams from 'src/containers/Settings/RundownTemplates/Form/WithParams';
import { RoleEnum } from 'src/hooks/useAuth';
import Home from 'src/pages/Home';
import NotFound from 'src/pages/NotFound/NotFound';
import RundownCalendar from 'src/pages/RundownCalendar/RundownCalendar';
import RundownDetail from 'src/pages/RundownDetail/RundownDetail';
import RundownOverview from 'src/pages/Rundowns/Rundown/Overview';
import GraphicPackageOverview from 'src/pages/Settings/GraphicPackages/Overview';
import RundownTemplateOverview from 'src/pages/Settings/RundownTemplates/Overview';
import Unauthorized from 'src/pages/Unauthorized/Unauthorized';

import Layout from './Layout';
import ProtectedRoute from './ProtectedRoute';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <ProtectedRoute allowedRoles={[RoleEnum.Operator, RoleEnum.Designer]} />,
        children: [
          {
            path: '',
            element: <Home />,
          },
          {
            path: '/rundown',
            element: <RundownCalendar />,
          },
          {
            path: '/rundown/:rundownId',
            element: <RundownDetail />,
          },
          {
            path: '/rundowns',
            element: <Navigate to="/rundowns/overview" replace />,
          },
          {
            path: '/medialibrary',
            element: <MediaLibrary />,
          },
          {
            path: '/rundowns/overview',
            element: <RundownOverview />,
          },
          {
            path: '/rundowns/create',
            element: <RundownFormWithParams />,
          },
          {
            path: '/rundowns/edit/:rundownId',
            element: <RundownFormWithParams />,
          },
        ],
      },
      {
        path: '/settings',
        element: <ProtectedRoute allowedRoles={[RoleEnum.Admin]} />,
        children: [
          {
            path: '',
            element: <Navigate to="/settings/templates" replace />,
          },
          {
            path: 'templates',
            element: <RundownTemplateOverview />,
          },
          {
            path: 'templates/create',
            element: <RundownTemplateFormWithParams />,
          },
          {
            path: 'templates/edit/:rundownTemplateId',
            element: <RundownTemplateFormWithParams />,
          },
          {
            path: 'graphicpackages',
            element: <GraphicPackageOverview />,
          },
          {
            path: 'workspace/outputs',
            element: <OutputOverview />,
          },
          {
            path: 'workspace/outputs/create',
            element: <OutputForm />,
          },
          {
            path: 'workspace/canvases',
            element: <CanvasOverview />,
          },
          {
            path: 'workspace/canvases/create',
            element: <CanvasForm />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
      },
      {
        path: '/unauthorized',
        element: <Unauthorized />,
      },
    ],
  },
];
